import VerifyOtpFormContainer from "./verify-otp-form.container";

export default VerifyOtpFormContainer